<template>
    <div class='form-group'>
        <label v-if='label'>
            {{ label }}
            <span v-if='required' class='text-danger'>*</span>
            <font-awesome-icon icon="info-circle" class="ms-1 text-info" v-if="info" v-tooltip="info" /><br>
            <small v-if='subInfo' class='text-info d-block' style="margin-top: -5px">{{ subInfo }}</small>
        </label>
        <textarea
            :class='["form-control", {"is-invalid" : errors && errors.length}]'
            :placeholder='placeholder'
            :value='modelValue'
            :disabled='disabled'
            :required='required'
            :autocomplete='autocomplete'
            @change='$emit("onChange", $event.target.value)'
            @input='updateValue'
            :rows="rows"
            :maxlength="maxLength"
        ></textarea>

        <div v-if='errors && errors.length' class='invalid-feedback' v-for='(error, index) in errors'
             :key='`invalid-feedback-${index}`'> {{ error }}
        </div>
        
        <div class="text-warning" v-if="maxLength && modelValue?.length >= maxLength">
            Você atingiu o limite máximo de {{maxLength}} caracteres.
        </div>
    </div>
</template>

<script setup>
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    const emit = defineEmits(['update:modelValue']);

    const props = defineProps({
        label: { type: String, default: null },
        placeholder: { type: String, default: '' },
        required: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        autocomplete: { type: String, default: '' },
        errors: { default: null },
        modelValue: { type: [String, Number] },
        rows: { type: Number, default: 3 },
        info: { type: String, default: '' },
        subInfo: { type: String, default: '' },
        maxLength: { type: Number, default: null }
    });

    const updateValue = (event) => {
        emit('update:modelValue', event.target.value);
    };
</script>
